var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "pip_exit_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pip_exit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 21h7c.283 0 .52-.096.712-.288A.968.968 0 0023 20v-4a.968.968 0 00-.288-.713A.968.968 0 0022 15h-7a.968.968 0 00-.713.287A.968.968 0 0014 16v4c0 .283.096.52.287.712.192.192.43.288.713.288zm-7 3c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 016 22V10c0-.55.196-1.02.588-1.412A1.926 1.926 0 018 8h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0124 24H8zm0-2h16V10H8v12z",
    fill: "#fff"
  }))));
}
export default SvgPipExit;